import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { MAIN_URL } from "../config/constants";

const GuestGuard = ({ children }) => {
  const { isLoggedIn } = useSelector((state) => state?.auth);

  if (isLoggedIn) {
    return <Navigate to={MAIN_URL} />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default GuestGuard;
